// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"16":"RequestRedirect","317":"InventoryList","833":"NotificationPage"}[chunkId] + "." + {"16":"577a13d4","317":"1c2d0a9b","833":"d35cc461"}[chunkId] + ".css";
};